module.exports = __webpack_public_path__ + "img/detail-active-line.8f9a537a.svg";